import { render, staticRenderFns } from "./SetupQBRulesAside.vue?vue&type=template&id=20b384e4&scoped=true&"
import script from "./SetupQBRulesAside.vue?vue&type=script&lang=js&"
export * from "./SetupQBRulesAside.vue?vue&type=script&lang=js&"
import style0 from "./SetupQBRulesAside.vue?vue&type=style&index=0&id=20b384e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b384e4",
  null
  
)

export default component.exports